import { render } from "./MdiArrowUpBoldIcon.vue?vue&type=template&id=e5734f88"
import script from "./MdiArrowUpBoldIcon.vue?vue&type=script&lang=js"
export * from "./MdiArrowUpBoldIcon.vue?vue&type=script&lang=js"
script.render = render

export default script